import axios from '@/libs/api.request'

export const getCostinfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/costinfo/costinfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationCostinfo = (data, meth) => {
  return axios.request({
    url: '/v1/costinfo/costinfo/',
    method: meth,
    data
  })
}